import { render, staticRenderFns } from "./PayEarn.vue?vue&type=template&id=023ada7a&scoped=true&"
var script = {}
import style0 from "./PayEarn.vue?vue&type=style&index=0&id=023ada7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ada7a",
  null
  
)

export default component.exports